import SpacePath from "components/SpacePath";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModuleVersionConsumerRow } from "../types";

const ModuleVersionConsumersTableSpaceCell = ({
  item: consumer,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionConsumerRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={consumer.spaceId} fallbackName={consumer.space} />
    </TableSimpleCell>
  );
};

export default ModuleVersionConsumersTableSpaceCell;
